var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "multiselect",
    _vm._b(
      {
        staticClass: "multiselect-rounded multiselect-blue",
        attrs: {
          value: _vm.value,
          options: _vm.options,
          searchable: false,
          "close-on-select": _vm.closeOnSelect,
          "show-labels": false,
          placeholder: _vm.placeholder,
          hideSelected: _vm.hideSelected,
        },
        on: { input: _vm.handleInput },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function ({ values, isOpen }) {
              return [
                values.length && !isOpen
                  ? _c("span", { staticClass: "multiselect__single" }, [
                      _vm._v(_vm._s(values.length) + " options selected"),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "multiselect",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }